import React, { useEffect, useState } from "react";
import { Cake } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const fmt = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { day: "numeric", month: "short" });

export default function BirthdayClubCard() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/pup-birthdays").then(({ data }) => setD(data)).catch(() => {}); }, []);
  const test = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/pup-birthdays/test"); toast.success(`Test treat email sent to ${data.to}`); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="birthday-club-admin">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-display font-bold text-[#19324A] inline-flex items-center gap-2"><Cake className="w-4 h-4 text-[#FF6B9D]" /> Pup Birthday Club</h3>
          <p className="text-xs text-[#19324A]/50 mt-0.5">Members get a {d.percent}% single-use code {d.days_before} days before their pup's birthday (sent by the 9am daily run). Public page: /pup-birthday-club</p>
        </div>
        <button onClick={test} disabled={busy} className="btn-outline !py-2 text-sm disabled:opacity-50" data-testid="birthday-send-test">{busy ? "Sending…" : "Send me a test"}</button>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-3 text-center">
        {[["Pups", d.total, "birthday-total"], ["Treats sent", d.treats_sent, "birthday-treats"], ["Redeemed", d.treats_redeemed, "birthday-redeemed"]].map(([l, v, t]) => (
          <div key={l} className="rounded-2xl bg-[#FFF9EE] p-3"><p className="font-display font-extrabold text-2xl text-[#19324A]" data-testid={t}>{v}</p><p className="text-[11px] uppercase tracking-wider text-[#19324A]/45">{l}</p></div>
        ))}
      </div>
      {d.upcoming.length > 0 ? (
        <ul className="mt-4 divide-y divide-[#19324A]/5" data-testid="birthday-upcoming">
          {d.upcoming.map((p) => (
            <li key={`${p.email}-${p.pup_name}`} className="py-2 flex items-center justify-between text-sm">
              <span className="text-[#19324A]"><strong>{p.pup_name}</strong>{p.age_turning ? ` turns ${p.age_turning}` : ""} <span className="text-[#19324A]/50">· {p.first_name || p.email}</span></span>
              <span className="text-xs text-[#19324A]/60">{fmt(p.next_birthday)} · {p.days_away === 0 ? "today" : `${p.days_away}d`}{p.treated_this_year ? " · treated ✓" : ""}</span>
            </li>
          ))}
        </ul>
      ) : <p className="text-sm text-[#19324A]/55 mt-4" data-testid="birthday-empty">No pups yet — share /pup-birthday-club with the Pack.</p>}
    </div>
  );
}
